import React from "react";
import styles from "./OverflowOnlineWithBible.module.css";

const OVERFLOW_URL = "https://overflow-pwa.netlify.app";

const OverflowOnlineWithBible = () => {
  const [isBibleOpen, setIsBibleOpen] = React.useState(false);
  const [isMobileUser, setIsMobileUser] = React.useState(false);

  function toggleBibleOpen() {
    setIsBibleOpen((prevBool) => !prevBool);
  }

  React.useEffect(() => {
    try {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        setIsMobileUser(true);
      }
    } catch {
      // I guess they get to use the desktop site... lol
    }
  }, [navigator]);

  if (isMobileUser) {
    try {
      window.location.replace(OVERFLOW_URL);
    } catch {
      /* DO SWEET NOTHINGS */
    }
    return <iframe class="iframe-overflow" src={OVERFLOW_URL} />;
  }

  return (
    <div className={styles.overflowOnlineWithBible}>
      <a
        target="_blank"
        className={styles.logoIcon}
        href="https://overflow.melos.church"
      >
        <img alt="Overflow App Logo" src="../logo.svg" />
      </a>
      <iframe
        className={styles.overflowAreaIframe}
        key="overflow"
        src={OVERFLOW_URL}
      />
      <p
        className={styles.createdWithByCamPDyl}
        id="attribution"
      >{`Created with ♥ by Cam P. & Dylan B.`}</p>
      {isBibleOpen ? (
        <section className={styles.frameSection} id="bible-lite-preview">
          <iframe
            className={styles.cleanShot20221017At0734}
            id="bible-lite-iframe"
            key="bible-lite"
            src="https://bible.app/app/"
          />
          <div className={styles.frameDiv}>
            <div className={styles.previewFromYouVersionsHttp}>
              Preview from YouVersion’s https://bible.app
            </div>
          </div>
        </section>
      ) : null}
      <button className={styles.button} onClick={toggleBibleOpen}>
        <div className={styles.buttonDiv}>
          {isBibleOpen ? (
            <>
              Close Bible
              <img className={styles.closeIcon} alt="" src="../close.svg" />
            </>
          ) : (
            "Open Bible"
          )}
        </div>
      </button>
    </div>
  );
};

export default OverflowOnlineWithBible;
